var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47574 7.56281C9.56204 7.56281 11.2659 5.87643 11.2659 3.77261C11.2659 1.68632 9.54475 0 7.47574 0C5.40674 0 3.68555 1.68638 3.68555 3.7902C3.68555 5.85914 5.38939 7.56281 7.47574 7.56281ZM7.47574 0.852101C9.07527 0.852101 10.4139 2.15603 10.4139 3.79026C10.4139 5.38979 9.10997 6.72841 7.47574 6.72841C5.87621 6.72841 4.53759 5.42448 4.53759 3.79026C4.53759 2.15603 5.87621 0.852101 7.47574 0.852101Z",
    fill: "#778CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7791 7.76735L10.5878 7.75L10.4662 7.87166C9.66645 8.63667 8.60583 9.07128 7.49319 9.07128C6.38054 9.07128 5.31993 8.63667 4.52022 7.87166L4.39856 7.75L4.17258 7.76735C1.84285 7.94128 0 9.9058 0 12.2705V15H14.9519L14.9517 12.2705C14.9692 9.90592 13.1089 7.9414 10.7792 7.76735H10.7791ZM14.0999 14.1305H0.851922V12.2703C0.851922 10.4275 2.24282 8.88012 4.0508 8.6542C4.98964 9.50606 6.18925 9.95813 7.4759 9.95813C8.76255 9.95813 9.9621 9.48872 10.901 8.6542C12.7092 8.86283 14.0999 10.4275 14.0999 12.2703V14.1305Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fbb44d92c7bf35c9fecfdc231c4f5a05.svg";
export { ForwardRef as ReactComponent };